/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleDTO } from './RoleDTO';
import {
    RoleDTOFromJSON,
    RoleDTOFromJSONTyped,
    RoleDTOToJSON,
} from './RoleDTO';

/**
 * 
 * @export
 * @interface UserDTO
 */
export interface UserDTO {
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    givename?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    email?: string;
    /**
     * 
     * @type {Array<RoleDTO>}
     * @memberof UserDTO
     */
    roles?: Array<RoleDTO>;
}

/**
 * Check if a given object implements the UserDTO interface.
 */
export function instanceOfUserDTO(value: object): value is UserDTO {
    return true;
}

export function UserDTOFromJSON(json: any): UserDTO {
    return UserDTOFromJSONTyped(json, false);
}

export function UserDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'givename': json['givename'] == null ? undefined : json['givename'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'email': json['email'] == null ? undefined : json['email'],
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(RoleDTOFromJSON)),
    };
}

export function UserDTOToJSON(value?: UserDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'givename': value['givename'],
        'surname': value['surname'],
        'email': value['email'],
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(RoleDTOToJSON)),
    };
}

